module.exports = __webpack_public_path__ + "static/media/bg18.25e641d7.jpg";